import Vue from "vue";

import VueRouter from "vue-router";

const Home = () => import('./components/Home.vue')
// const About = () => import('./components/About.vue')
const BigDataLondon = () => import('./components/BigDataLondon.vue')

const Pricing = () => import('./components/sections/pricing/Pricing.vue')
const Features = () => import('./components/sections/product/Features.vue')
const Docker = () => import('./components/sections/product/Docker.vue')
const Refunds = () => import('./components/sections/terms/Refunds.vue')
const Terms = () => import('./components/sections/terms/Terms.vue')

const Privacy = () => import('./components/sections/terms/Privacy.vue')
const WebsiteTerms = () => import('./components/sections/terms/WebsiteTerms.vue')
const Disclaimer = () => import('./components/sections/terms/Disclaimer.vue')
const Eula = () => import('./components/sections/terms/Eula.vue')
const Contact = () => import('./components/sections/Contact.vue')

const Developer = () => import('./components/Developer.vue')

// const Datalakes = () => import('./components/sections/product/Datalakes.vue')
// const EltCdc = () => import('./components/sections/product/EltCdc.vue')
// const EventSourcing = () => import('./components/sections/product/EventSourcing.vue')
// const SaasData = () => import('./components/SaasData.vue')
// const Athena = () => import('./components/sections/integrations/Athena.vue')
// const Dbt = () => import('./components/sections/integrations/Dbt.vue')
// const DeltaLake = () => import('./components/sections/integrations/DeltaLake.vue')
// const ApacheArrow = () => import('./components/sections/integrations/ApacheArrow.vue')
// const Signup = () => import('./components/Signup.vue')
const DeployWizard = () => import('./components/sections/deploy-wizard/DeployWizard.vue')
// const Snowflake = () => import("./components/sections/integrations/Snowflake")


import LogoutSuccess from './components/LogoutSuccess'
import AuthError from './components/AuthError'

import UserInfoStore from './userstore';
import UserInfo from './userinfo';
import auth from './auth';
import AxiosLicense from './plugins/axioslicense'


Vue.use(VueRouter)

function requireAuth(to, from, next) {

  if (!auth.auth.isUserSignedIn()) {
    UserInfoStore.setLoggedIn(false);

    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  } else {
    UserInfo.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true);
      UserInfoStore.setCognitoInfo(response);
      next();
    });

  }
}

export default new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Home, name: 'home' },
    // Just use them normally in the route config
    { path: '/home', component: Home, name: 'home' },

    { path: '/big-data-london', component: BigDataLondon, name: 'big-data-london' },


    // { path: '/about', component: About, name: 'about' },
    { path: '/pricing', component: Pricing, name: 'pricing' },
    { path: '/contact-us', component: Contact, name: 'contact-us' },
    { path: '/deploy-wizard', component: DeployWizard, name: 'deploy-wizard'},
    { path: '/deploy', component: DeployWizard , name: 'deploy'},
    { path: '/license', component: DeployWizard, beforeEnter: requireAuth, name: 'license' },
    // Bar and Baz belong to the same root route
    // and grouped in the same async chunk.
    { path: '/features', component: Features, name: 'features' },
    { path: '/docker', component: Docker, name: 'docker' },
    { path: '/terms/refunds', component: Refunds, name: 'refunds' },
    { path: '/terms', component: Terms, name: 'terms' },
    { path: '/terms/privacy', component: Privacy, name: 'privacy' },
    { path: '/terms/website-terms', component: WebsiteTerms, name: 'website terms' },
    { path: '/terms/disclaimer', component: Disclaimer, name: 'disclaimer' },
    { path: '/terms/eula', component: Eula, name: 'eyla' },

    { path: '/developer', component: Developer, name: 'developer' },

    // { path: '/datalakes', component: Datalakes, name: 'datalakes' },
    // { path: '/elt-cdc', component: EltCdc },
    // { path: '/event-sourcing', component: EventSourcing },
    // { path: '/sass-data-integration', component: SaasData },

    // { path: '/snowflake-skippr', component: Snowflake },
    // { path: '/athena-skippr', component: Athena },
    // { path: '/dbt-skippr', component: Dbt },
    // { path: '/deltalake-skippr', component: DeltaLake },
    // { path: '/apache-arrow-skippr', component: ApacheArrow },

    {
      path: '/login', beforeEnter(){
        auth.auth.getSession();
      }
    },
    {
      path: '/login/oauth2/code/cognito', beforeEnter(){
        var currUrl = window.location.href;
        auth.auth.parseCognitoWebResponse(currUrl);
        AxiosLicense.authAxios();
        // next();
      }
    },
    {
      path: '/logout', component: LogoutSuccess, beforeEnter(to, from, next){
        auth.logout();
        next();
      }
    },
    {
      path: '/error', component: AuthError
    }
  ],
})
